import { post } from 'app/shared/utils/fetchr';

// Models
import { PaginatedAgentsPayload } from 'app/modules/agents/requests';

// Utils
import routes from 'app/shared/utils/routes';

export const retrieveDropdownAgents = (payload: PaginatedAgentsPayload) => {
  return post(routes.patronus.agentsAutocomplete, payload);
};
